
import type { SelectionContext, GridRow, GridColumn } from '../types/gridTypes';

export const createEmptySelection = (gridId: string): SelectionContext => ({
  gridId,
  selectedRowIds: [],
  selectedColumnIds: [],
  mode: 'none'
});

export const getSelectionRange = (
  rows: GridRow[],
  columns: GridColumn[],
  startRowId: string,
  startColId: string,
  endRowId: string,
  endColId: string
): { rowIds: string[]; colIds: string[] } => {
  const startRowIdx = rows.findIndex(r => r.id === startRowId);
  const endRowIdx = rows.findIndex(r => r.id === endRowId);
  const startColIdx = columns.findIndex(c => c.id === startColId);
  const endColIdx = columns.findIndex(c => c.id === endColId);

  if (startRowIdx === -1 || endRowIdx === -1 || startColIdx === -1 || endColIdx === -1) {
    return { rowIds: [], colIds: [] };
  }

  const rMin = Math.min(startRowIdx, endRowIdx);
  const rMax = Math.max(startRowIdx, endRowIdx);
  const cMin = Math.min(startColIdx, endColIdx);
  const cMax = Math.max(startColIdx, endColIdx);

  const rowIds = rows.slice(rMin, rMax + 1).map(r => r.id);
  const colIds = columns.slice(cMin, cMax + 1).map(c => c.id);

  return { rowIds, colIds };
};
